module.exports = "<ul class=\"billmenu-new header\">\n  <li routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact: true}\">\n    <a [routerLink]=\"['/home/payroll/']\">Allowance Master</a>\n  </li>\n  <li routerLinkActive=\"active\"><a [routerLink]=\"['deduction-code-grid']\">Deduction Master</a></li> \n  <li routerLinkActive=\"active\"><a [routerLink]=\"['formula']\">Formula</a></li> \n</ul>\n<div class=\"overflow\">\n  <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-masters/payroll-masters.component.html
// module id = ./src/app/hrms/payroll/payroll-masters/payroll-masters.component.html
// module chunks = main